export class ResponsibilityDto {
    userId: number;
    email: string;
    activeDirectoryId: string;
    activeDirectoryDisplayName: string;
    canDelete: boolean;
    isManual: boolean;
}